<script>

import {asyncAngularInvoke} from '/vodalys/vvuejs'



export default {
  components: {  },
  props: ['component', 'handler'],
  computed: {},
  methods: {
    displayPopup: function () {
        let _zis = this
        asyncAngularInvoke(function ($rootScope, $rootElement, v17Modal) {
            v17Modal.ok($rootScope, $rootElement.find('body'), {
                'title' : 'Welcome to the Vodalys platform!',
                'rawhtml' : true,
                'content': `<div style="max-width:500px">Enjoy advanced features of cloud video mixer (production projects) and professional web video player (player projects).<br>`,
                okLabel: 'Got it !',
                ok : function()
                {
                    return _zis.handler.action(_zis.component, 'gotit', [])
                }
            })
        })
    },
  },
  mounted : function ()
  {
      if (this.component.already_gotit)
      {
          console.log('already gotit!')
      }
      else
      {         
        setTimeout(()  => {
            this.displayPopup()
        }, 5000)
      }
  }
};


</script>

<template>
</template>
<style lang="scss" scoped>
</style>